import { User } from 'core/models/user.model';

/**
 * Um usuário ativo por perfil SGE - e-mails @oneeduca.com.br.
 * Senha SSO (OneAuth / demo): Admin123
 */
export const MOCK_USERS: User[] = [
  {
    id: 'user-superadmin',
    name: 'Super Admin',
    email: 'superadmin@oneeduca.com.br',
    role: 'SUPER_ADMIN',
    active: true,
    hasSystemAccess: true,
    createdAt: '2025-01-10T10:00:00.000Z',
    updatedAt: '2026-03-01T14:30:00.000Z',
  },
  {
    id: 'user-plataforma',
    name: 'Admin da plataforma',
    email: 'plataforma@oneeduca.com.br',
    role: 'PLATFORM_ADMIN',
    active: true,
    hasSystemAccess: true,
    createdAt: '2025-02-12T08:00:00.000Z',
    updatedAt: '2026-02-10T09:15:00.000Z',
  },
  {
    id: 'user-suporte',
    name: 'Suporte',
    email: 'suporte@oneeduca.com.br',
    role: 'SUPPORT',
    active: true,
    hasSystemAccess: true,
    createdAt: '2025-05-01T09:00:00.000Z',
    updatedAt: '2025-11-20T13:00:00.000Z',
  },
  {
    id: 'user-institucional',
    name: 'Admin institucional',
    email: 'institucional@oneeduca.com.br',
    role: 'INSTITUTION_ADMIN',
    institutionId: 'inst-001',
    staff: {
      educationFunction: 'school_manager',
      formationLevel: 'postgraduate',
      courseName: 'Gestão escolar',
      formations: [
        {
          formationLevel: 'postgraduate',
          courseName: 'Gestão escolar',
        },
      ],
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2025-03-05T12:00:00.000Z',
    updatedAt: '2025-12-18T16:45:00.000Z',
  },
  {
    id: 'user-professor',
    name: 'Professor',
    email: 'professor@oneeduca.com.br',
    role: 'TEACHER',
    institutionId: 'inst-001',
    person: {
      cpf: '12345678901',
      birthDate: '1988-04-12',
      sex: 'female',
      raceColor: 'brown',
      motherName: 'Maria Silva',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    staff: {
      educationFunction: 'teacher',
      formationLevel: 'complete_higher',
      courseName: 'Licenciatura em Matemática',
      formations: [
        {
          formationLevel: 'complete_higher',
          courseName: 'Licenciatura em Matemática',
        },
        {
          formationLevel: 'postgraduate',
          courseName: 'Especialização em Educação',
        },
      ],
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2025-04-20T11:00:00.000Z',
    updatedAt: '2026-01-08T10:00:00.000Z',
  },
  {
    id: 'user-apoio',
    name: 'Auxiliar de turma',
    email: 'apoio@oneeduca.com.br',
    role: 'TEACHER',
    institutionId: 'inst-001',
    person: {
      cpf: '32165498700',
      birthDate: '1995-11-03',
      sex: 'female',
      raceColor: 'brown',
      motherName: 'Lucia Apoio',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    staff: {
      educationFunction: 'support_staff',
      supportFunction: 'monitor',
      formationLevel: 'complete_high_school',
      employmentType: 'clt',
      formations: [
        {
          formationLevel: 'complete_high_school',
        },
      ],
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-02-01T10:00:00.000Z',
    updatedAt: '2026-02-01T10:00:00.000Z',
  },
  {
    id: 'user-aluno',
    name: 'Aluno',
    email: 'aluno@oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '10987654321',
      birthDate: '2013-08-20',
      sex: 'male',
      raceColor: 'white',
      motherName: 'Ana Souza',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-20T10:00:00.000Z',
    updatedAt: '2026-01-20T10:00:00.000Z',
  },
  {
    id: 'user-aluno-02',
    name: 'Ana Clara Mendes',
    email: 'ana.clara@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '52998224725',
      birthDate: '2014-03-11',
      sex: 'female',
      raceColor: 'brown',
      motherName: 'Patrícia Mendes',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-21T10:00:00.000Z',
    updatedAt: '2026-01-21T10:00:00.000Z',
  },
  {
    id: 'user-aluno-03',
    name: 'Bruno Oliveira',
    email: 'bruno.oliveira@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '15350946056',
      birthDate: '2013-11-02',
      sex: 'male',
      raceColor: 'black',
      motherName: 'Luciana Oliveira',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-21T10:05:00.000Z',
    updatedAt: '2026-01-21T10:05:00.000Z',
  },
  {
    id: 'user-aluno-04',
    name: 'Camila Santos',
    email: 'camila.santos@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '39053344705',
      birthDate: '2014-07-19',
      sex: 'female',
      raceColor: 'white',
      motherName: 'Fernanda Santos',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-21T10:10:00.000Z',
    updatedAt: '2026-01-21T10:10:00.000Z',
  },
  {
    id: 'user-aluno-05',
    name: 'Diego Ferreira',
    email: 'diego.ferreira@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '07691107000',
      birthDate: '2013-01-28',
      sex: 'male',
      raceColor: 'brown',
      motherName: 'Simone Ferreira',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-21T10:15:00.000Z',
    updatedAt: '2026-01-21T10:15:00.000Z',
  },
  {
    id: 'user-aluno-06',
    name: 'Eduarda Lima',
    email: 'eduarda.lima@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '23100299900',
      birthDate: '2014-09-05',
      sex: 'female',
      raceColor: 'white',
      motherName: 'Carla Lima',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-21T10:20:00.000Z',
    updatedAt: '2026-01-21T10:20:00.000Z',
  },
  {
    id: 'user-aluno-07',
    name: 'Felipe Rocha',
    email: 'felipe.rocha@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '11144477735',
      birthDate: '2013-05-14',
      sex: 'male',
      raceColor: 'indigenous',
      motherName: 'Joana Rocha',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-21T10:25:00.000Z',
    updatedAt: '2026-01-21T10:25:00.000Z',
  },
  {
    id: 'user-aluno-08',
    name: 'Giovana Alves',
    email: 'giovana.alves@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '22233344405',
      birthDate: '2014-12-22',
      sex: 'female',
      raceColor: 'yellow',
      motherName: 'Helena Alves',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-21T10:30:00.000Z',
    updatedAt: '2026-01-21T10:30:00.000Z',
  },
  {
    id: 'user-aluno-09',
    name: 'Henrique Costa',
    email: 'henrique.costa@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '33344455576',
      birthDate: '2012-06-08',
      sex: 'male',
      raceColor: 'white',
      motherName: 'Beatriz Costa',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-21T10:35:00.000Z',
    updatedAt: '2026-03-01T10:00:00.000Z',
  },
  {
    id: 'user-aluno-10',
    name: 'Isabela Martins',
    email: 'isabela.martins@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '44455566647',
      birthDate: '2013-10-30',
      sex: 'female',
      raceColor: 'brown',
      motherName: 'Renata Martins',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-21T10:40:00.000Z',
    updatedAt: '2026-01-21T10:40:00.000Z',
  },
  {
    id: 'user-aluno-11',
    name: 'João Pedro Nunes',
    email: 'joao.nunes@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '55566677718',
      birthDate: '2009-04-12',
      sex: 'male',
      raceColor: 'brown',
      motherName: 'Márcia Nunes',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-22T10:00:00.000Z',
    updatedAt: '2026-01-22T10:00:00.000Z',
  },
  {
    id: 'user-aluno-12',
    name: 'Larissa Dias',
    email: 'larissa.dias@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '66677788889',
      birthDate: '2009-08-21',
      sex: 'female',
      raceColor: 'white',
      motherName: 'Sônia Dias',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-22T10:05:00.000Z',
    updatedAt: '2026-01-22T10:05:00.000Z',
  },
  {
    id: 'user-aluno-13',
    name: 'Mateus Barbosa',
    email: 'mateus.barbosa@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '77788899950',
      birthDate: '2008-12-03',
      sex: 'male',
      raceColor: 'black',
      motherName: 'Eliane Barbosa',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-22T10:10:00.000Z',
    updatedAt: '2026-01-22T10:10:00.000Z',
  },
  {
    id: 'user-aluno-14',
    name: 'Natália Freitas',
    email: 'natalia.freitas@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '88899900021',
      birthDate: '2009-02-17',
      sex: 'female',
      raceColor: 'brown',
      motherName: 'Denise Freitas',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-22T10:15:00.000Z',
    updatedAt: '2026-01-22T10:15:00.000Z',
  },
  {
    id: 'user-aluno-15',
    name: 'Otávio Ribeiro',
    email: 'otavio.ribeiro@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '99900011192',
      birthDate: '2012-05-09',
      sex: 'male',
      raceColor: 'white',
      motherName: 'Cristina Ribeiro',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-22T10:20:00.000Z',
    updatedAt: '2026-01-22T10:20:00.000Z',
  },
  {
    id: 'user-aluno-16',
    name: 'Paula Mendes',
    email: 'paula.mendes@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '10120230344',
      birthDate: '2012-09-25',
      sex: 'female',
      raceColor: 'brown',
      motherName: 'Andréa Mendes',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-22T10:25:00.000Z',
    updatedAt: '2026-01-22T10:25:00.000Z',
  },
  {
    id: 'user-aluno-17',
    name: 'Rafael Souza',
    email: 'rafael.souza@aluno.oneeduca.com.br',
    role: 'STUDENT',
    institutionId: 'inst-001',
    person: {
      cpf: '20230340415',
      birthDate: '2011-11-14',
      sex: 'male',
      raceColor: 'black',
      motherName: 'Vera Souza',
      nationality: 'Brasileira',
      city: 'São Paulo',
      state: 'SP',
      locationZone: 'urban',
    },
    active: true,
    hasSystemAccess: true,
    createdAt: '2026-01-22T10:30:00.000Z',
    updatedAt: '2026-01-22T10:30:00.000Z',
  },
  {
    id: 'user-responsavel',
    name: 'Responsável',
    email: 'responsavel@oneeduca.com.br',
    role: 'GUARDIAN',
    institutionId: 'inst-001',
    active: true,
    hasSystemAccess: true,
    createdAt: '2025-09-01T09:00:00.000Z',
    updatedAt: '2026-01-20T10:00:00.000Z',
  },
  {
    id: 'user-secretaria',
    name: 'Secretaria',
    email: 'secretaria@oneeduca.com.br',
    role: 'SECRETARY',
    institutionId: 'inst-001',
    active: true,
    hasSystemAccess: true,
    createdAt: '2025-08-12T09:00:00.000Z',
    updatedAt: '2026-01-20T10:00:00.000Z',
  },
  {
    id: 'user-financeiro',
    name: 'Financeiro',
    email: 'financeiro@oneeduca.com.br',
    role: 'FINANCE',
    institutionId: 'inst-001',
    active: true,
    hasSystemAccess: true,
    createdAt: '2025-08-15T09:00:00.000Z',
    updatedAt: '2026-01-20T10:00:00.000Z',
  },
  {
    id: 'user-transporte',
    name: 'Operador de transporte',
    email: 'transporte@oneeduca.com.br',
    role: 'TRANSPORT_OPERATOR',
    institutionId: 'inst-001',
    active: true,
    hasSystemAccess: true,
    createdAt: '2025-08-18T09:00:00.000Z',
    updatedAt: '2026-01-20T10:00:00.000Z',
  },
];
